// Builtin types:
//  - 'string' (default)	string
//  - 'number'	number
//  - 'date'	Date() object
//  - 'dateTime'	Date() object
//  - 'boolean'	boolean
//  - 'singleSelect'	A value in .valueOptions
//  - 'actions'	Not applicable

export const getCommons = ({ field, model }) => {
  return {
    type: "string",
    headerName: field.label,
    field: field.name,
    width: field.width || 100,
    _meta: { field, model },
    sortable: field.sortable === true,
    filterable: field.filterable === true,
    filterOperators: field.filterOperators,
    align: field.align || undefined,
  };
};
